"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneCountryCodeSelect = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireDefault(require("react"));
var _Translated = _interopRequireDefault(require("../Translated"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const PhoneCountryCodeSelect = _ref => {
  let {
    countryCodes,
    FormControlProps = {},
    label = /*#__PURE__*/_react.default.createElement(_Translated.default, {
      id: "phone_country_code"
    }),
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_core.FormControl, _extends({
    fullWidth: true
  }, FormControlProps), /*#__PURE__*/_react.default.createElement(_core.InputLabel, {
    shrink: true
  }, label), /*#__PURE__*/_react.default.createElement(_core.Select, _extends({
    disableUnderline: true,
    renderValue: index => {
      if (typeof index !== 'number') {
        return index;
      }
      return `+${countryCodes[index].phoneCode}`;
    },
    "data-testid": "phone-country-code-select"
  }, props), countryCodes.map((_ref2, index) => {
    let {
      name,
      phoneCode,
      isoCountryCode
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      value: index,
      key: `+${phoneCode}(${isoCountryCode})`
    }, name, "\xA0", `+${phoneCode}`);
  })));
};
exports.PhoneCountryCodeSelect = PhoneCountryCodeSelect;